import { partitionConnections, type Connection, type Integration } from "../../../../types/integration";

// One connected business-app account for the tenant, flattened with its parent
// integration so each row shows both what is connected and which account.
export type ConnectedRow = {
  readonly integration: Integration;
  readonly connection: Connection;
};

// Flatten each integration's live business-app connections into one row apiece.
// Two things are dropped: channel connections (WhatsApp/Telegram — those live in
// the Channels modal, not here) and soft-deleted (`disconnected`) rows, which
// the backend keeps only for history. Active connections sort to the top, then
// alphabetically by integration title, so an operator sees live ones first.
export const connectedRows = (
  integrations: ReadonlyArray<Integration>,
): ConnectedRow[] => {
  const rows: ConnectedRow[] = [];
  for (const integration of integrations) {
    const { businessApp } = partitionConnections(
      integration.connections ?? [],
      integration.channel,
    );
    for (const connection of businessApp) {
      if (connection.status === "disconnected") continue;
      rows.push({ integration, connection });
    }
  }
  const rank = (r: ConnectedRow): number => (r.connection.status === "active" ? 0 : 1);
  return rows.sort((a, b) => {
    const byStatus = rank(a) - rank(b);
    if (byStatus !== 0) return byStatus;
    return a.integration.title.localeCompare(b.integration.title);
  });
};
